import script from "./VersionUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionUpdate.vue?vue&type=script&setup=true&lang=js"

import "./VersionUpdate.vue?vue&type=style&index=0&id=378c29c5&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-378c29c5"]])

export default __exports__